export const galleryGuideKey = 'siteFront.galleryGuideHidden.v1';
export const galleryGuideApplyEvent = 'site-front:gallery-guide-apply';
let sessionValue: boolean | undefined;

export function readGalleryGuideHidden() {
    if (sessionValue !== undefined) return sessionValue;
    try { return localStorage.getItem(galleryGuideKey) === '1'; } catch { return false; }
}

export function writeGalleryGuideHidden(value: boolean) {
    sessionValue = value;
    try { localStorage.setItem(galleryGuideKey, value ? '1' : '0'); } catch {}
}

export function applyGalleryGuideHidden() {
    window.dispatchEvent(new Event(galleryGuideApplyEvent));
}

export function refreshGalleryGuideStorage(event: StorageEvent) {
    if (event.key !== galleryGuideKey && event.key !== null) return;
    sessionValue = undefined;
    applyGalleryGuideHidden();
}
